// import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';

// @Component({
//   selector: 'app-select',
//   templateUrl: './select.component.html',
//   styleUrls: ['./select.component.scss']
// })
// export class SelectComponent implements OnInit, OnChanges{
//   @Input() options: any[] | null = null;
//   @Input() keyLabel: string | null = null;
//   @Input() keyValue: string | null = null;
//   @Input() multiSelect: boolean = false;
//   // @Input() selectedValue: any;
//   @Input() labelInSelect: boolean = false;
//   @Input() label:string = '';

//   private _selectedValue: any;

//   @Input()
//   get selectedValue(): any {
//       return this._selectedValue;
//   }

//   set selectedValue(val: any) {
//     // debugger;
//       this._selectedValue = val;
//       this.initializeSelectedOptions();
//   }

//   // @Input() useSideImage: boolean = false;
//   // @Input() sideImageKey: string | null = null;
//   @Input() class: string | null = null;

//   @Output() selectionChange = new EventEmitter<any | any[]>();

//   selectedOptions: any[] = [];
//   dropdownOpen = false;

//   ngOnInit() {
//     this.initializeSelectedOptions();
//   }

//   ngOnChanges(changes: SimpleChanges) {
//     if (changes['selectedValue'] && changes['selectedValue'].currentValue) {
//       // debugger;
//       this.initializeSelectedOptions();
//     }
//   }

//   initializeSelectedOptions() {
//     if (!this.multiSelect && this.selectedValue != null) {
//       this.selectedOptions = [this.selectedValue];
//     } else if (this.multiSelect && this.selectedValue != null) {
//       this.selectedOptions = Array.isArray(this.selectedValue) ? [...this.selectedValue] : [this.selectedValue];
//     }
//   }
//   replace(value: string){
//     return value.replace('-',' ').toLowerCase()
//   }

//   selectOption(option: any) {
//     if (this.multiSelect) {
//       const index = this.selectedOptions.indexOf(option);
//       if (index > -1) {
//         this.selectedOptions.splice(index, 1);
//       } else {
//         this.selectedOptions.push(option);
//       }
//       this.selectionChange.emit(this.selectedOptions);
//     } else {
//       this.selectedOptions = [option];
//       this.selectionChange.emit(option);
//     }
//     this.dropdownOpen = false;
//   }

//   toggleDropdown() {
//     this.dropdownOpen = !this.dropdownOpen;
//   }

//   getOptionLabel(option: any): string {
//     return this.keyLabel && option ? option[this.keyLabel] : option;
//   }

//   getOptionValue(option: any): any {
//     return this.keyValue && option ? option[this.keyValue] : option;
//   }

//   isOptionSelected(option: any): boolean {
//     return this.selectedOptions.includes(option);
//   }

//   getDisplayText(): string {
//     if (!this.selectedOptions.length) {
//       return 'Select option';
//     }

//     if (this.multiSelect) {
//       return this.selectedOptions.map(option => this.getOptionLabel(option)).join(', ');
//     }

//     return this.getOptionLabel(this.selectedOptions[0]);
//   }
// }
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'app-select',
  templateUrl: './select.component.html',
  styleUrls: ['./select.component.scss'],
})
export class SelectComponent implements OnInit {
  @Input() options: any[] | null = null;
  @Input() keyLabel: string | null = null;
  @Input() keyValue: string | null = null;
  @Input() multiSelect: boolean = false;
  @Input() labelInSelect: boolean = false;
  @Input() label: string = '';
  @Input() class: string | null = null;

  private selectedValueSubject = new BehaviorSubject<any>(null);
  private _selectedValue: any;

  @Input()
  set selectedValue(val: any) {
    this._selectedValue = val;
    this.selectedValueSubject.next(val);
  }

  get selectedValue(): any {
    return this._selectedValue;
  }

  @Output() selectionChange = new EventEmitter<any | any[]>();

  selectedOptions: any[] = [];
  dropdownOpen = false;

  ngOnInit() {
    this.selectedValueSubject.subscribe({
      next: (val) => {
        this.selectedOptions = this.multiSelect
          ? Array.isArray(val)
            ? [...val]
            : []
          : [val];
      },
    });
  }

  selectOption(option: any) {
    if (this.multiSelect) {
      const index = this.selectedOptions.findIndex((o) => o === option);
      if (index > -1) {
        this.selectedOptions.splice(index, 1);
      } else {
        this.selectedOptions.push(option);
      }
    } else {
      this.selectedOptions = [option];
      this._selectedValue = option;
    }
    this.selectionChange.emit(this.multiSelect ? this.selectedOptions : option);
    this.dropdownOpen = false;
  }

  toggleDropdown() {
    this.dropdownOpen = !this.dropdownOpen;
  }

  getOptionLabel(option: any): string {
    return this.keyLabel && option ? option[this.keyLabel] : option;
  }

  isOptionSelected(option: any): boolean {
    return this.selectedOptions.includes(option);
  }

  getDisplayText(): string {
    if (!this.selectedOptions.length) return 'Select option';
    return this.selectedOptions
      .map((option) => this.getOptionLabel(option))
      .join(', ');
  }

  replace(value: string) {
    return value.replace('-', ' ').toLowerCase();
  }
}
